import(/* webpackMode: "eager", webpackExports: ["AuthGuard"] */ "/vercel/path0/src/components/AuthGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopShell"] */ "/vercel/path0/src/components/desktop/DesktopShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopShellSkeleton"] */ "/vercel/path0/src/components/desktop/DesktopShellSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dock"] */ "/vercel/path0/src/components/desktop/Dock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useWindowManager","useWindowManagerState","DOCK_APPS"] */ "/vercel/path0/src/components/desktop/useWindowManager.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Window"] */ "/vercel/path0/src/components/desktop/Window.tsx");
